// src/services/email/signaturTelefon.ts
//
// Telefonnummer in Mail-Signaturen des Intranets. Inhaltsgleich mit
// netlify/functions/_shared/signaturTelefon.js; das Intranet kann die
// Server-Datei nicht einbinden.
//
// Die Nummer gehört zu der Person, deren Name in der Signatur steht. Die eigene
// Durchwahl erscheint nur, wenn durchwahlInSignatur gesetzt und eine gültige
// Nummer hinterlegt ist. In allen anderen Fällen erscheint die Zentrale.

import { EmailSenderIdentity } from './types';

const ZENTRALE_TELEFON = '+492216505419800';

// Gespeichertes Format in xtax_staff.telefon: "+" gefolgt von Ziffern.
const GUELTIGE_NUMMER = /^\+\d{8,15}$/;

/**
 * Schreibweise wie bisher in den Signaturen:
 * "+492216505419801" wird zu "+49 221 6505419801".
 */
function formatiereTelefon(nummer: string): string {
  const koeln = nummer.match(/^\+49221(\d+)$/);
  if (koeln) {
    return `+49 221 ${koeln[1]}`;
  }
  return nummer;
}

/**
 * Liefert die Telefonnummer für die Signatur der übergebenen Person.
 * Ohne Person erscheint die Zentrale.
 */
export function signaturTelefon(sender?: EmailSenderIdentity | null): string {
  if (sender && sender.durchwahlInSignatur === true) {
    const nummer = typeof sender.telefon === 'string' ? sender.telefon.trim() : '';
    if (GUELTIGE_NUMMER.test(nummer)) {
      return formatiereTelefon(nummer);
    }
    console.warn(`[Signatur-Telefon] Durchwahl aktiviert, aber keine gültige Nummer für ${sender.fullName || 'unbekannt'}. Zentrale wird verwendet.`);
  }
  return formatiereTelefon(ZENTRALE_TELEFON);
}
